import { render, staticRenderFns } from "./LatestProperties.vue?vue&type=template&id=263fb456"
import script from "./LatestProperties.vue?vue&type=script&lang=js"
export * from "./LatestProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports